import {fetchAndDeserialize} from '../../../util/api-adapter';

import {reviewAnalysisSourcesResponseSchema, ReviewAnalysisSourceType} from './review-analysis-sources-type';

export function fetchReviewsAnalysisSources(): Promise<Array<ReviewAnalysisSourceType>> {
    const url = `/v2/reviews-analytics/stats/sources-info/`;

    return fetchAndDeserialize(url, reviewAnalysisSourcesResponseSchema);
}
